import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { getDevices } from "./actions";
import { IAdminState } from "./reducer";

import { withAuth, withTitle } from "../../HoC";
import { DeviceWrapper } from "../../Components/Devices";
import { translate } from "../../translations/translate";
import { Header } from "../../Components/Header/Header";

export const AdminPage = (props) => {
  useEffect(() => {
    props.actions.getDevices();
  }, []);

  return (<div style={{ textAlign: "center" }}>
    <Header withProfile />
    <h1 style={{ margin: "20px 0px", color: "white" }}> {translate("admin.title")} </h1>
    <DeviceWrapper
      devices={props.adminReducer.devices}
    />
  </div>);
};

const mapStateToProps = (state: { adminReducer: IAdminState }) => ({
  adminReducer: state.adminReducer,
});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
    getDevices,
  }, dispatch),
});

export default compose(
  withTitle(translate("admin-page")),
  withAuth(0),
  connect(mapStateToProps, mapDispatchToProps),
)(AdminPage);
